import type { ChatListFilter } from '../../../lib/core/definitions'

const getChatListFilter = (activeUserId: string): ChatListFilter => ({
  userIds: [activeUserId, undefined],
})

export default getChatListFilter
